<textarea class="input-text" #input [value]="text ? text : null" (blur)="onBlur()"></textarea>
<button *ngIf="viewModel.doOnSave" (click)="onSave()">Save</button>
<button *ngIf="viewModel.doOnCancel" (click)="onCancel()">Cancel</button>
